var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6158 1.00613L16.675 9.13005L18.7072 4.33705L27.6158 1.00613Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38406 1.00607L13.226 9.20694L11.2927 4.33699L2.38406 1.00607Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6835 19.8373L20.7725 24.3005L27.0009 26.0154L28.7804 19.9362L23.6835 19.8373Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23071 19.9362L2.99925 26.0154L9.22758 24.3005L6.32762 19.8373L1.23071 19.9362Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88719 12.2961L7.15161 14.9234L13.325 15.1983L13.1163 8.54742L8.88719 12.2961Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1129 12.2961L16.8179 8.47046L16.675 15.1982L22.8485 14.9234L21.1129 12.2961Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22748 24.3006L12.9513 22.4867L9.74376 19.9803L9.22748 24.3006Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0486 22.4867L20.7725 24.3006L20.2562 19.9803L17.0486 22.4867Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7724 24.3005L17.0486 22.4867L17.3452 24.9161L17.3122 25.9385L20.7724 24.3005Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22748 24.3009L12.6877 25.9389L12.6657 24.9165L12.9513 22.487L9.22748 24.3009Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7537 18.3753L9.65601 17.4629L11.842 16.4625L12.7537 18.3753Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2463 18.3753L18.158 16.4625L20.3549 17.4629L17.2463 18.3753Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22751 24.3005L9.76576 19.8373L6.32755 19.9362L9.22751 24.3005Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2342 19.8373L20.7724 24.3005L23.6834 19.9362L20.2342 19.8373Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8485 14.9234L16.675 15.1983L17.2463 18.3753L18.158 16.4625L20.3549 17.4628L22.8485 14.9234Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.656 17.4628L11.842 16.4625L12.7537 18.3753L13.3249 15.1983L7.15149 14.9234L9.656 17.4628Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15161 14.9236L9.744 19.9805L9.65612 17.4631L7.15161 14.9236Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.355 17.4628L20.2561 19.9803L22.8485 14.9234L20.355 17.4628Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3249 15.1979L12.7537 18.3749L13.4787 22.1236L13.6324 17.1877L13.3249 15.1979Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.675 15.1979L16.3784 17.1767L16.5212 22.1236L17.2462 18.3749L16.675 15.1979Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2464 18.3752L16.5214 22.1239L17.0487 22.4867L20.2562 19.9802L20.3551 17.4628L17.2464 18.3752Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65601 17.4628L9.74388 19.9802L12.9514 22.4867L13.4787 22.1239L12.7537 18.3752L9.65601 17.4628Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3122 25.9385L17.3452 24.9162L17.0706 24.6743H12.9293L12.6657 24.9162L12.6877 25.9385L9.22748 24.3006L10.4358 25.2899L12.8964 26.9939H17.1035L19.5641 25.2899L20.7724 24.3006L17.3122 25.9385Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0487 22.4868L16.5214 22.124H13.4786L12.9514 22.4868L12.6658 24.9162L12.9294 24.6744H17.0706L17.3453 24.9162L17.0487 22.4868Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0773 9.65766L29 5.17247L27.6159 1.00607L17.0486 8.85516L21.113 12.296L26.858 13.978L28.1212 12.4939L27.572 12.0981L28.4508 11.2956L27.7807 10.768L28.6595 10.0974L28.0773 9.65766Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.17265L1.9337 9.65784L1.34053 10.0976L2.2193 10.7682L1.54924 11.2958L2.42801 12.0983L1.87878 12.4941L3.14202 13.9781L8.88702 12.2962L12.9514 8.85535L2.38407 1.00626L1 5.17265Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8579 13.9779L21.1129 12.296L22.8485 14.9233L20.2561 19.9802L23.6833 19.9362H28.7802L26.8579 13.9779Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88705 12.296L3.14205 13.9779L1.23071 19.9362H6.32762L9.74386 19.9802L7.15147 14.9233L8.88705 12.296Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6751 15.1984L17.0486 8.85533L18.7073 4.33716H11.2926L12.9513 8.85533L13.3248 15.1984L13.4676 17.1991L13.4786 22.124H16.5213L16.5323 17.1991L16.6751 15.1984Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.b4dce355738e764c3c909a6367956d97.svg";
export { ForwardRef as ReactComponent };